import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';

import { BaseUI } from '../../../base.ui';
import { ClientRelation, ClientType } from '../../../../../core';
import { FullClient } from '../../../../domain/data';
import { ParentEvents } from '../../../../utils/parent-events.service';

@Component({
    selector: 'thr-view-profile-legal-table',
    templateUrl: './view-profile-legal-table.component.html',
    styleUrls: ['./view-profile-legal-table.component.scss'],
})
export class ViewProfileLegalTableComponent extends BaseUI implements AfterViewInit, OnDestroy {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;

    @Input()
    participants: FullClient[] = [];

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }
}
